import { cleanPhone } from "./cleanPhone";

export function generateWhatsappLink(
  phoneNumber,
  message,
  isCatalogue = false,
) {
  /**
   * Return a link redirecting to WhatsApp with message already written
   *
   * phoneNumber: 0609867103
   */
  return encodeURI(
    `https://wa.me/${isCatalogue ? "c/" : ""}${cleanPhone(phoneNumber)}${isCatalogue ? "" : `?text=${message}`}`,
  );
}
